import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles, { scrollableTableContainer } from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const LovCoA = ({ show, data, onClose, onSelect }) => {
  const [search, setSearch] = useState("");

  if (!show) return null;

  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  const filteredData = formattedData.filter((item) =>
    [
      item?.chart_account_code,
      item?.chart_account_desc,
      item?.group_account_code,
      item?.group_account_desc,
      item?.group_account_dep,
      item?.group_account_div,
      item?.group_account_table,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      minWidth: "70px",
      maxWidth: "100px",
      sortable: true,
      center: true,
    },
    {
      name: "Chart Code",
      selector: (row) => row.chart_account_code,
      sortable: true,
      minWidth: "130px",
      center: true,
    },
    {
      name: "Chart Desc",
      selector: (row) => row.chart_account_desc,
      sortable: true,
      minWidth: "250px",
    },
    {
      name: "Div",
      selector: (row) => row.group_account_div,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Table",
      selector: (row) => row.group_account_table,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Aksi",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => onSelect(row)}
        >
          Pilih
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "100px",
      center: true,
    },
  ];

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Pilih Chart of Account</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <input
                type="text"
                placeholder="Cari kode, nama, grup..."
                className="form-control"
                style={{ maxWidth: 300 }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div style={scrollableTableContainer}>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                customStyles={DatatableStyles}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 25]}
                paginationComponentOptions={paginationOptions}
                responsive={true}
                noDataComponent="Tidak ada data yang cocok"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LovCoA;
